// All actions and client-side state related to a User

import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { createItemOnServer } from "../api/api";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";


// Firebase Login - errors not caught here
export const loginUser = createAsyncThunk(
    'user/loginUser',
    async (credentials, { dispatch }) => {
      try {
        dispatch(setLoading(true));

        // Firebase login
        const { email, password } = credentials;
        console.log("Logging in with email and password: ", email, password);
        const auth = getAuth();
        signInWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
            // Signed in 
            const userToken = userCredential;
            console.log("User logged in successfully: ", userToken);
            dispatch(setLoading(false));
            // ...
        })
        .catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            console.log("Error logging in: ", errorCode, errorMessage);
            setError(errorMessage);
            dispatch(setLoading(false));
        });

      } catch (error) {
        dispatch(setError(error.message));
        dispatch(setLoading(false));
      }
    }
  );
  
  export const logoutUser = createAsyncThunk(
    'user/logoutUser',
    async (_, { dispatch }) => {
      try {
        dispatch(setLoading(true));
        dispatch(clearUser());
        dispatch(setLoading(false));
      } catch (error) {
        dispatch(setError(error.message));
        dispatch(setLoading(false));
      }
    }
  );


// Async thunk to add a user
export const addUserToReduxAndServer = createAsyncThunk(
    'user/addUser',
    async (user, thunkAPI) => {
        try {
            // Send a POST request to create the user on the server
            const newUser = await createItemOnServer('users', user);

            return newUser;
        } catch (error) {
            // Return the rejected promise with the error message
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

// Async thunk to update user
export const updateUserOnReduxAndServer = createAsyncThunk(
    'user/updateUser',
    async ({ id, updatedUser, dispatch }, thunkAPI) => {
        try {
            const updated = await createItemOnServer('users', updatedUser);
            dispatch(setUserLoaded(true));
            return { id, updatedUser: updated };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const initialState = {
    // user: { username, email, hearts, groups }
    user: null,
    loading: true,
    error: null,
    authToken: null,
    isUserLoaded: false,
};

export const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        updateUser: (state, action) => {
            state.user = action.payload;
        },
        clearUser: (state) => {
            state.user = null;
            state.isUserLoaded = false;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        setUserLoaded: (state, action) => {
            state.isUserLoaded = action.payload;
        },
        setAuthToken: (state, action) => {
            state.authToken = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(addUserToReduxAndServer.fulfilled, (state, action) => {
            state.user = action.payload;
        })
            .addCase(addUserToReduxAndServer.pending, (state, action) => {
            console.log("Adding user to server...");
        })
            .addCase(addUserToReduxAndServer.rejected, (state, action) => {
            console.error("Error adding user to server: ", action.payload);
        })
            .addCase(updateUserOnReduxAndServer.fulfilled, (state, action) => {
            const { id, updatedUser } = action.payload;
            state.user = updatedUser;
        })
            .addCase(updateUserOnReduxAndServer.pending, (state, action) => {
            console.log("Updating user on server...");
        })
            .addCase(updateUserOnReduxAndServer.rejected, (state, action) => {
            console.error("Error updating user on server: ", action.payload);
        })
            .addCase(loginUser.fulfilled, (state, action) => {
                state.authToken = action.payload;
        })
            .addCase(loginUser.pending, (state, action) => {
            console.log("Logging in user...");
        })
            .addCase(loginUser.rejected, (state, action) => {
            console.error("Error logging in user: ", action.payload);
        })
    },
});

// export the actions
export const { updateUser, clearUser, setLoading, setError, setUserLoaded, setAuthToken} = userSlice.actions;

// export the reducer
export default userSlice.reducer;